import { Component, Input } from '@angular/core';

@Component({
  selector: 'ui-fh-svg-canceled',
  templateUrl: './fh-svg-canceled.component.html',
  styleUrl: './fh-svg-canceled.component.scss'
})
export class FhSvgCanceledComponent {
  @Input() color: string = '';
}
